var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5C9.82843 4.5 10.5 3.82843 10.5 3C10.5 2.17157 9.82843 1.5 9 1.5C8.17157 1.5 7.5 2.17157 7.5 3C7.5 3.17157 7.54486 3.33421 7.625 3.475L4.475 5.525C4.33421 5.44486 4.17157 5.4 4 5.4C3.17157 5.4 2.5 6.07157 2.5 6.9C2.5 7.72843 3.17157 8.4 4 8.4C4.17157 8.4 4.33421 8.35514 4.475 8.275L7.625 10.325C7.54486 10.4658 7.5 10.6284 7.5 10.8C7.5 11.6284 8.17157 12.3 9 12.3C9.82843 12.3 10.5 11.6284 10.5 10.8C10.5 9.97157 9.82843 9.3 9 9.3C8.82843 9.3 8.66579 9.34486 8.525 9.425L5.375 7.375C5.45514 7.23421 5.5 7.07157 5.5 6.9C5.5 6.72843 5.45514 6.56579 5.375 6.425L8.525 4.375C8.66579 4.45514 8.82843 4.5 9 4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.58171dc6b1bd873507445a8db622970b.svg";
export { ForwardRef as ReactComponent };